import abhi from "./ExTeam/images/abhinil.jpg";
import devansh from "./ExTeam/images/devansh.jpg";
import sid from "./ExTeam/images/sidharth.jpg";
import aditya from "./ExTeam/images/aditya.jpg";
import shashi from "./ExTeam/images/shashi.jpg";
// import abhi from "./Heads/abhi.jpeg";
import samyu from "./ExTeam/images/samyu.jpg";
import vidit from "./ExTeam/images/vidit.jpg";
import hari from "./ExTeam/images/hariom.jpg";

const gensec2022 = [
  {
    img: abhi,
    name: "Abhinil Kumar",
    pos: "General Secretary",
    fb: "https://www.facebook.com/abhinil07",
    insta: "",
    linkedin: "https://www.linkedin.com/in/abhinilkumar07/",
    contact: "",
    mail: "",
  },
  {
    img: devansh,
    name: "Devansh Srivastava",
    pos: "General Secretary",
    fb: "https://www.facebook.com/devansh.srivastava.1671?__tn__=-]K*F",
    linkedin: "https://www.linkedin.com/in/devansh-srivastava-97004620b/",
    contact: "",
    mail: "",
  },
];

const eventHead2022 = [
  // {
  //   name: "Aditya Mohite",
  //   pos: "Senior Coordinator",
  //   img: aditya,
  //   fb: "https://www.facebook.com/aditya.mohite.5245?__tn__=-]K*F",
  //   linkedin: "https://www.linkedin.com/in/adityamohiteiit/",
  //   contact: "#",
  //   mail: "#",
  // },
  // {
  //   name: "Samyukta Kagdelwar",
  //   img: samyu,
  //   pos: "Senior Coordinator",
  //   fb: "https://www.facebook.com/samyukta.kagdelwar",
  //   linkedin: "https://www.linkedin.com/in/samyukta-kagdelwar-1027b020b/",
  //   contact: "#",
  //   mail: "#",
  // },
  {
    img: shashi,
    name: "Shashi Ranjan",
    pos: "Senior Coordinator",
    fb: "https://www.facebook.com/profile.php?id=100056269372029",
    linkedin: "https://www.linkedin.com/in/shashi-ranjan-861612210/",
    contact: "#",
    mail: "#",
  },
];
// const sponsHead2022 = [
//   {
//     img: shashi,
//     name: "Shashi Ranjan",
//     pos: "Senior Coordinator",
//     fb: "https://www.facebook.com/profile.php?id=100056269372029",
//     linkedin: "https://www.linkedin.com/in/shashi-ranjan-861612210/",
//     contact: "#",
//     mail: "#",
//   },
//   {
//     name: "Samyukta Kagdelwar",
//     img: samyu,
//     pos: "Senior Coordinator",
//     fb: "https://www.facebook.com/samyukta.kagdelwar",
//     linkedin: "https://www.linkedin.com/in/samyukta-kagdelwar-1027b020b/",
//     contact: "#",
//     mail: "#",
//   },
// ];
const designHead2022 = [
  {
    name: "Siddharth Ghankot",
    img: sid,
    pos: "Senior Coordinator",
    fb: "https://www.facebook.com/siddharth.ghankot?__tn__=-]K*F",
    linkedin: "https://www.linkedin.com/in/siddharth-ghankot-3aa015210/",
    contact: "#",
    mail: "#",
  },

  {
    name: "Vidit Gupta",
    pos: "Web Design Coordinator",
    img: vidit,
    fb: "https://www.facebook.com/vidit.gupta.79",
    insta: "#",
    linkedin: "#",
    mail: "#",
    contact: "#",
  },
  {
    name: "Hariom Chaudhari",
    img: hari,
    pos: "Web & Graphics Design Coordinator",
    fb: "https://www.facebook.com/ChaudhariHariomVijay",
    linkedin: "https://www.linkedin.com/in/chaudharihariomvijay/",
    contact: "#",
    mail: "#",
  },
];

export { gensec2022, designHead2022, eventHead2022 };
